import React from "react";
import { Page } from "../../components/page/page";
import styles from "./tradition.module.css";
import { ChooseButton } from "../../components/choose-button/choose-button";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setTradition } from "../../store/stateSlice";

const options = [
  {
    value: "I feel deeply connected to the wisdom of traditions",
    icon: "🤩",
  },
  {
    value: "I appreciate the history but also value modern ways",
    icon: "😌",
  },
  {
    value: "I prefer to focus on the present rather than the past",
    icon: "🙂",
  },
  {
    value: "Not sure",
    icon: "🤔",
  },
];

const TraditionPage = () => {
  const dispatch = useDispatch();
  return (
    <Page
      title="Do you find yourself drawn to ancient customs and rituals?"
      hideContinueButton={true}
      currentStep={9}
    >
      <ul className={styles.list}>
        {options.map((option, i) => (
          <li key={i}>
            <Link
              to="../ancestor"
              onClick={() => dispatch(setTradition(option.value))}
            >
              <ChooseButton icon={option.icon}>{option.value}</ChooseButton>
            </Link>
          </li>
        ))}
      </ul>
    </Page>
  );
};

export { TraditionPage };
